/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
export const APPLICATION_STATUS_BASIC = 10;
export const APPLICATION_STATUS_ALIMONY = 15;
export const APPLICATION_STATUS_CHILDREN = 20;
export const APPLICATION_STATUS_PETITIONER = 30;
export const APPLICATION_STATUS_PARTNER = 40;
export const APPLICATION_STATUS_MESSAGE = 45;
export const APPLICATION_STATUS_DOCUMENTS = 47;
export const APPLICATION_STATUS_CONTACT = 50;
export const APPLICATION_STATUS_INSURANCE = 60;
export const APPLICATION_STATUS_SUMMARY = 100;

export const ALIMONY_APPLICATION_STATUS_SET = [
  APPLICATION_STATUS_BASIC,
  APPLICATION_STATUS_ALIMONY,
  APPLICATION_STATUS_CHILDREN,
  APPLICATION_STATUS_PETITIONER,
  APPLICATION_STATUS_PARTNER,
  APPLICATION_STATUS_MESSAGE,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_CONTACT,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_SUMMARY,
];
export const applicationStatuses = {
  APPLICATION_STATUS_BASIC,
  APPLICATION_STATUS_ALIMONY,
  APPLICATION_STATUS_CHILDREN,
  APPLICATION_STATUS_PETITIONER,
  APPLICATION_STATUS_PARTNER,
  APPLICATION_STATUS_MESSAGE,
  APPLICATION_STATUS_CONTACT,
  APPLICATION_STATUS_SUMMARY,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_DOCUMENTS,
};
